"use client";

import { useEffect } from "react";
import { useAuth } from "@/context/auth-context";

const PIXEL_ID = "961503515048521";
// const PIXEL_ID = "1402357756561054";

/**
 * Re-initialises the Meta Pixel with Advanced Matching data whenever the
 * logged-in user changes. The browser pixel auto-hashes all PII with SHA-256
 * before transmitting — no server-side hashing needed.
 */
export default function MetaPixelUser() {
  const { user } = useAuth();

  useEffect(() => {
    if (typeof fbq === "undefined") return;

    if (user) {
      fbq("init", PIXEL_ID, {
        em: user.email,
        fn: user.first_name?.toLowerCase(),
        ln: user.last_name?.toLowerCase(),
        ph: user.cellphone?.replace(/\D/g, ""), // digits only
        external_id: String(user.id),
        ct: user.city?.toLowerCase(),
        country: "mx",
      });
    } else {
      // Logged-out: init without user data
      fbq("init", PIXEL_ID);
    }
    fbq("track", "PageView");
  }, [user]);

  return null;
}
